import {useQuery} from 'react-query'
import {deleteTeamLeader, fetchTeamLeaderList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import TeamLeaderForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import {APIResponse} from '../../../types/type'
import {TeamLeaderBase} from './type'
import DeleteLabel from '../../../components/DeleteLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import PortalDropdown from '../../../components/PortalDropdown'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import TopBarProgress from 'react-topbar-progress-indicator'
import NFC from './NFC'
import clsx from 'clsx'

const teamLeaderBreadcrumbs = [
  {
    title: 'User Management',
    path: 'user-management/team-leader',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function TeamLeader() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery<APIResponse<TeamLeaderBase[]>>(
    'teamLeader',
    fetchTeamLeaderList,
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    active_status: ({value}: {value: string}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    Actions: ({row}: {row: {original: TeamLeaderBase}}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={
                <span>
                  RFID of <span className="text-primary">{row.original.name}</span>
                </span>
              }
              initialValues={row.original}
              Form={NFC}
              modalAttrs={{size: 'sm'}}
              onSubmit={refetch}
              triggerClassName="d-block"
            >
              <div className="px-3 py-2">
                <i
                  className={clsx(
                    'fa-brands fa-nfc-symbol fs-6',
                    row.original?.nfc_code ? 'link-info' : 'link-secondary'
                  )}
                />
                <span className="ms-2">RFID</span>
              </div>
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Team Leader'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={TeamLeaderForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteTeamLeader(row.original.teamleader_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Team Leader</title>
      </Helmet>
      <PageTitle breadcrumbs={teamLeaderBreadcrumbs}>Team Leader</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.TeamLeader}
          fieldToLabelMap={viewProps.TeamLeader.primaryFieldsToLabelMap}
          Form={TeamLeaderForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <>
              <ModalWithForm
                modalTitle={'Add TeamLeader'}
                triggerClassName="ms-auto"
                onSubmit={refetch}
                Form={TeamLeaderForm}
                modalAttrs={{size: 'sm'}}
              >
                <Button size="sm">Add Team Leader</Button>
              </ModalWithForm>
              {/* <ModalWithForm
                modalTitle={'NFC Upload'}
                onSubmit={refetch}
                Form={NFCUpload}
                initialValues={{type: 'teamLeader'}}
              >
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex align-items-center gap-2 ps-4 pe-3 text-primary border border-primary rounded-3 ms-4"
                >
                  <span>NFC Upload</span>
                  <KTIcon iconName="file-up" className="fs-3 text-primary" />
                </Button>
              </ModalWithForm> */}
            </>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default TeamLeader
